import { Box, Link } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";
import theme from "../../../utils/theme";
import { ProtectedComponent } from "../../Authz/Protected";

export default function NavLink(props) {
  const { title, path, icon: Icon, isShown } = props;

  const location = useLocation();

  const show = isShown ? isShown() : true;

  return show ? (
    <Link
      component={RouterLink}
      sx={{
        padding: "12.4px 12px",
        margin: "0 8px",
        borderRadius: "4px",
        color: theme.colors.darkGrey,
        textDecoration: "none",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        "&:hover": {
          background: theme.colors.lighterBlue,
          color: theme.colors.blue,
          "& > svg": {
            color: theme.colors.blue,
          },
          display: "flex",
          justifyContent: "flex-start",
        },
        ...(location.pathname === path && {
          background: theme.colors.lightBlue,
          color: theme.colors.blue,
          "&:before": {
            content: `''`,
            width: 4,
            height: 16,
            position: "absolute",
            borderTopRightRadius: "3px",
            borderBottomRightRadius: "3px",
            background: theme.colors.darkBlue,
            left: 8,
          },
        }),
      }}
      to={path}
    >
      <Icon
        sx={{
          mr: "8px",
          fontSize: theme.fontSize.large,
          marginLeft: "2.5px",
          color:
            location.pathname === path
              ? theme.colors.blue
              : theme.colors.darkGrey,
        }}
      />
      <Box
        component="span"
        sx={{
          fontSize: theme.fontSize.medium,
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          overflow: "hidden",
          height: 16.01,
        }}
      >
        {title}
      </Box>
    </Link>
  ) : null;
}

NavLink.propTypes = {
  title: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  icon: PropTypes.elementType.isRequired,
  isShown: PropTypes.func,
};

NavLink.defaultProps = {
  isShown: () => true,
};

export function ProtectedNavLink(props) {
  const { permission, ...navLinkProps } = props;
  return (
    <ProtectedComponent
      WrappedComponent={NavLink}
      permission={permission}
      {...navLinkProps}
    />
  );
}

ProtectedNavLink.propTypes = {
  permission: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]).isRequired,
};
